import React, { ChangeEvent, useEffect, useState } from "react";
import { ITkNameTextProps } from "../../../../type/componentsType/TkSuperPowerText";
import TkLabelText from "../../../atoms/TkLabelText";
import "../_style.scss";
import { Box, Typography } from "@mui/material";
import { convertionBankFormat } from "../../../atoms/TkLabelText/hooks/useTools";

/**
 * 特殊テキストボックス部品
 * 氏名を入力するためのグループフォーム
 * TkNameTextコンポーネントは、名前を入力するためのテキストフィールドを表示します。
 * @param {ITkNameTextProps} props - コンポーネントのプロパティ
 * @param {string} props.name - 名前
 * @param {boolean} props.useFurigana - フリガナを使用するかどうか
 * @param {boolean} props.hafWidth - 半角幅で表示するかどうか
 * @param {number} props.size - テキストフィールドのサイズ
 * @param {(value: string) => void} props.onChange - 名前が変更されたときに呼び出されるコールバック関数
 * @return TkNameTextコンポーネント 特殊テキストボックス部品
 */
export const TkNameText: React.FC<ITkNameTextProps> = (props) => {
  const {
    size = "small",
    onChange,
    disabled = false,
    wantToSetValue = "",
    inputProps,
    useFurigana = false,
    onGetInputValue,
    hafWidth,
    firstNameLabel = false,
    convertBankFormat = false,
    ...rest
  } = props;
  const nameList = wantToSetValue?.split(/[　 ]+/) ?? [];
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");

  useEffect(() => {
    setLastName(nameList[0] || "");
    setFirstName(nameList[1] || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantToSetValue]);

  const combineNamesWithSpace = (
    firstName: string | undefined,
    lastName: string | undefined,
    halfWidth: boolean = false
  ): string => {
    if (!firstName && !lastName) {
      return "";
    }

    const space = halfWidth ? " " : "　";
    return `${firstName}${space}${lastName}`;
  };

  useEffect(() => {
    if (lastName?.match(/[ 　]/g)) {
      setLastName(lastName.replace(/\s+/g, ""));
    } else if (firstName?.match(/[ 　]/g)) {
      setFirstName(firstName.replace(/\s+/g, ""));
    }
  }, [lastName, firstName]);

  const handleNameChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    name: "firstName" | "lastName",
    isBlur?: boolean
  ) => {
    let newValue = event.target.value;
    if (convertBankFormat && isBlur) {
      newValue = convertionBankFormat(newValue);
    }

    let newName = "";
    let NameCheck = "";
    let firstNameForReturn = "";
    let lastNameForReturn = "";

    switch (name) {
      case "lastName":
        setLastName(newValue || "");
        lastNameForReturn = newValue;
        firstNameForReturn = firstName || "";
        newName = combineNamesWithSpace(newValue, firstName, hafWidth);
        NameCheck = `${newValue}${firstName}`;
        break;
      case "firstName":
        setFirstName(newValue || "");
        firstNameForReturn = newValue;
        lastNameForReturn = lastName || "";
        newName = combineNamesWithSpace(lastName, newValue, hafWidth);
        NameCheck = `${lastName}${newValue}`;
        break;
    }

    onChange?.({
      target: {
        value: newName,
        valueForShow: NameCheck,
        firstName: firstNameForReturn,
        lastName: lastNameForReturn,
      },
    });

    onGetInputValue?.({
      firstName: firstNameForReturn,
      lastName: lastNameForReturn,
    });
  };

  const className = "nameInputLabel";
  const labelTextProps = {
    className,
    ...rest,
  };

  return (
    <Box className="nameInput" data-testid="tkNameTextInput">
      <TkLabelText
        value={lastName}
        size={size}
        label={useFurigana ? (hafWidth ? "ｾｲ" : "セイ") : "姓"}
        onChange={(e) => handleNameChange(e, "lastName")}
        {...labelTextProps}
        onBlur={(e) => handleNameChange(e, "lastName", true)}
        error={rest.error}
        helperText={rest.helperText}
        disabled={disabled}
        InputProps={{
          inputProps: {
            ...inputProps,
            "data-testid": "tkNameSei",
          },
        }}
        wantToSetValue={lastName}
      />

      {firstNameLabel ? (
        <Typography className={className}>{firstName}</Typography>
      ) : (
        <TkLabelText
          value={firstName}
          size={size}
          label={useFurigana ? (hafWidth ? "ﾒｲ" : "メイ") : "名"}
          fullWidth
          onChange={(e) => handleNameChange(e, "firstName")}
          {...labelTextProps}
          onBlur={(e) => handleNameChange(e, "firstName", true)}
          error={rest.error}
          helperText={rest.error ? "　" : ""}
          disabled={disabled || rest.firstNameDisabled}
          InputProps={{
            inputProps: {
              ...inputProps,
              "data-testid": "tkNameMei",
            },
          }}
          wantToSetValue={firstName}
        />
      )}
    </Box>
  );
};
export default TkNameText;
